import React from "react";
import { Dialog, DialogProps } from "../../layout";
import { Icon } from "../..";
import { Icomoon } from "../../brand";
import "./EnquiryActionDialog.scss";

interface Props extends Pick<DialogProps, "isOpen" | "onClose"> {
  onWaitForCustomerClick: () => void;
  onSnoozeClick: () => void;
  onAddToToDoListClick: () => void;
  onArchiveClick: () => void;
}

const CurrentMarker: React.FC<{ isCurrent: boolean }> = ({ isCurrent }) => <>
  {isCurrent &&
    <>
      <span className="text--small is-pulled-right">Current</span>
      <div className="is-clearfix" />
    </>
  }
</>

/**
 * Component to prompt the LTO to do something with an enquiry. See #3178
 * 
 * @status development
 */
export const EnquiryActionDialog: React.FC<Props> = (props) => {
  return (
    <Dialog
      isOpen={props.isOpen}
      onClose={props.onClose}
      ariaLabel="Dialog to choose next action for this enquiry"
      className="enquiry-action-dialog has-text-centered"
      hasCloseButton
    >
      <h1 className="heading--3">What would you like to do with this enquiry?</h1>
      <div className="columns">
        <div className="column is-12">
          <button
            type="button"
            onClick={props.onWaitForCustomerClick}
            className="enquiry-action-dialog__button enquiry-action-dialog__button--wait"
          >
            <CurrentMarker isCurrent />
            <Icon icomoon={Icomoon.starFull2} />
            <h2 className="heading--3">Wait for customer</h2>
            <p>This enquiry will not be displayed in your focus tab until the customer replies or{" "}
              you need to follow up.</p>
          </button>
        </div>
      </div>
      <div className="columns">
        <div className="column is-4">
          <button
            type="button"
            onClick={props.onSnoozeClick}
            className="enquiry-action-dialog__button enquiry-action-dialog__button--snooze has-text-left-tablet"
          >
            <CurrentMarker isCurrent />
            <Icon icomoon={Icomoon.starFull2} />
            <h2 className="heading--3">Snooze</h2>
            <p>Snooze this enquiry until a later date.</p>
          </button>
        </div>
        <div className="column is-4">
          <button
            type="button"
            onClick={props.onAddToToDoListClick}
            className="enquiry-action-dialog__button enquiry-action-dialog__button--todo has-text-left-tablet"
          >
            <CurrentMarker isCurrent />
            <Icon icomoon={Icomoon.starFull2} />
            <h2 className="heading--3">Add to To-Do list</h2>
            <p>Keep track of this enquiry if there&apos;s something that you need to do next.</p>
          </button>
        </div>
        <div className="column is-4">
          <button
            type="button"
            onClick={props.onArchiveClick}
            className="enquiry-action-dialog__button enquiry-action-dialog__button--archive has-text-left-tablet"
          >
            <CurrentMarker isCurrent />
            <Icon icomoon={Icomoon.starFull2} />
            <h2 className="heading--3">Archive</h2>
            <p>Hide this enquiry from your dashboards unless the customer sends a reply.</p>
          </button>
        </div>
      </div>
      <p>Closing this window without selecting anything will keep the enquiry as _______.</p>
    </Dialog>
  )
};
